export default __webpack_public_path__ + "static/media/play_module.2e49fb05.svg";